export function checkSectionVisibility(sectionVisibility, element){
    if(sectionVisibility == 'optional'){
        // element.prepend('<span class="close removeSectionClose edit" aria-hidden="true" title="Remove this Section">&times;</span>')
        element.prepend('<div class="button removeSectionClose edit hidden">Remove This Section</div>')
    }

    element.on('click','.removeSectionClose' ,function(){
        element.addClass("removeSection");
        element.prepend('<span class="optional-section-overlay"></span><div class="optional-section-include"><div class="button includeButton">Include This Section Again</div></div>');
        $("ul.menu__nav>li.page_link.menuLink").find(".nav_input[id=nav_"+element.attr('id')+"]").addClass("removeMenuItem")    
    })

    element.on('click', '.includeButton', function(){        
        element.removeClass("removeSection");
        element.find(".optional-section-overlay").remove()
        element.find(".optional-section-include").remove();
        $("ul.menu__nav>li.page_link.menuLink").find(".nav_input[id=nav_"+element.attr('id')+"]").removeClass("removeMenuItem")
    });
}